import {
  Button,
  Icon,
  Modal,
  type ModalProps,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { useNavigate } from 'react-router';

import { INTEGRATIONS_PATH } from '../../../constants';

const TITLE = 'Congratulations!';
const DESCRIPTION =
  'Your Xero integration has been successfully configured and connected.';
const BUTTON_LABEL = 'Go to Integrations';

type XeroCongratsModalProps = {
  modalProps: Omit<ModalProps, 'children'>;
  handleClose: () => void;
};

export const XeroCongratsModal = ({ modalProps }: XeroCongratsModalProps) => {
  const navigate = useNavigate();
  return (
    <Modal {...modalProps} span={6}>
      <Modal.Body>
        <Stack align="center">
          <Icon icon="CircleCheck" size="32" color="positive" />
          <Typography as="span" size="16" weight="medium">
            {TITLE}
          </Typography>
          <Typography as="span" size="14">
            {DESCRIPTION}
          </Typography>
          <Button onClick={() => navigate(INTEGRATIONS_PATH)}>
            {BUTTON_LABEL}
          </Button>
        </Stack>
      </Modal.Body>
    </Modal>
  );
};
